import React, { useRef, useEffect, useState } from "react";
import _ from "lodash";
import moment from "moment";
import { AtRiskDraw } from "./AtRiskDraw";
import AtRiskTable from "./AtRiskTable";
import { wholeNumberWithCommas } from "../../utils/NumberFormatter";
import SubmissionModal from "../../common/SubmissionModal";
import { useFetch } from "../../Hooks/useFetch";
import { FetchBoundary } from "../../common/FetchBoundary";

const AtRiskIndex = (props) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const entityID = urlParams.get("id");

  const [submitClaimsModal, setSubmitClaimsModal] = useState(false);

  const [searchQuery, setSearchQuery] = useState({
    id_340b: entityID ? entityID : props.entities[0].value,
    manufacturer: props.manufacturers[0].value,
  });

  const pharmaciesFetcher = useFetch(
    `${props.query_path}?id_340b=${searchQuery.id_340b}&manufacturer=${searchQuery.manufacturer}`
  );

  const pharmacies = pharmaciesFetcher.data?.pharmacies ?? [];

  const [filterQuery, setFilterQuery] = useState({
    status: null,
  });

  const handleFilter = (name, value) => {
    setFilterQuery({ ...filterQuery, [name]: value });
  };

  const handleSearch = (name, value) => {
    setSearchQuery({ ...searchQuery, [name]: value });
  };

  const getFilters = () => {
    var filters = {};

    _.each(filterQuery, (value, key) => {
      if (value && value.length) _.assign(filters, { [key]: value });
    });

    return filters;
  };

  const filteredPharmacies = () => _.filter(pharmacies, getFilters());

  const isLoading = pharmaciesFetcher.loading;
  const isEmpty = !isLoading && pharmacies.length == 0;

  return (
    <div className="flex">
      <div className="content__container">
        <div className="page-details__container mb-3">
          <div className="page-details__container__info">
            <div className="page-details__title">At Risk and Suspended Pharmacies</div>
            <div className="breadcrumbs__container">
              <div className="breadcrumbs__crumb breadcrumbs__crumb__active">Reports</div>
            </div>
          </div>
          <div className="mt-4">
            <div className="tile__well" style={{ maxWidth: 530 }}>
              <div className="tile flex justify-content-between flex-row gap--24">
                <div className="flex flex-shrink-0 flex-column">
                  <div className="tile__header tile__header--spread">
                    <div className="t--md t--500">At Risk and Suspended Pharmacies</div>
                  </div>
                  <div className="flex__container flex__container--align-center">
                    <div className="t--500 t--xl">
                      {wholeNumberWithCommas(filteredPharmacies().length)}
                    </div>
                  </div>
                </div>
                <div>
                  <div className="t--secondary t--sm mb-3">
                    Pharmacies are considered At Risk or Suspended when there are insufficient
                    claims to support the covered entity purchases. To rectify, submit claims for
                    your entity.
                  </div>
                  <button
                    className="button button--white"
                    onClick={() => setSubmitClaimsModal(true)}
                  >
                    Submit Claims
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <FetchBoundary {...pharmaciesFetcher}>
          {isEmpty ? (
            <div className="bg--light-gray flex align-items-center justify-content-center border--rounded t--sm t--secondary w--full h--96">
              The current selection and filters returned no results.
            </div>
          ) : (
            <AtRiskTable pharmacies={filteredPharmacies()} isLoading={isLoading} />
          )}
        </FetchBoundary>
      </div>
      <div className="draw__container">
        <AtRiskDraw
          entities={props.entities}
          downloadPath={props.download_path}
          setSearchQuery={setSearchQuery}
          searchQuery={searchQuery}
          handleSearch={handleSearch}
          handleFilter={handleFilter}
          manufacturers={props.manufacturers}
        />
      </div>
      {submitClaimsModal ? (
        <SubmissionModal
          organizationId={props.organization_id}
          handleCloseModal={() => setSubmitClaimsModal(false)}
        />
      ) : null}
    </div>
  );
};

export default AtRiskIndex;
